export enum FilteringEngineEnum {
    ALL = 'Wszystko',
    EMPLOYEES = 'Pracownicy',
    POSITIONS = 'Role',
    PROJECTS = "Projekty"
}